import { FieldError } from "react-hook-form";

type Props = {
    error: FieldError;
}

/**
 * Renders a react-hook-form field error message. Both client-side (zod) and
 * server-mapped errors are now plain front-end strings, so the message is
 * rendered verbatim — no HTML sanitization or anchor parsing is needed.
 */
export function ServerErrorMessage({ error }: Props) {
    return error.message ?? null;
}
